// extracted by mini-css-extract-plugin
module.exports = {"locationCard":"LocationCard_locationCard__2gfKH","locationCardContainer":"LocationCard_locationCardContainer__2ApM6","info":"LocationCard_info__1M9Xv"};